import { z } from 'zod';

export const createClientSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  industry: z.string().min(1, 'Industry is required'),
  contactEmail: z.string().email('Must be a valid email address'),
  contactName: z.string().min(1, 'Contact name is required'),
  status: z.enum(['active', 'suspended']),
});

export type CreateClientFormValues = z.infer<typeof createClientSchema>;
